export const Constants = {
  currentUser: 'currentUserTrendmultiApp',
  currentTotalUsers: 'currentTotalUsers',
  currentMaxUsersCompany: 'currentMaxUsersCompany',
  currentInfo: 'currentInfo_',
  kanbanSelectedFunnelId: 'kanbanSelectedFunnelId',
  monitoringPreferences: 'monitoringPreferences',
  supportWhatsappUrl: 'http://wa.me/556199925827?text=Ol%C3%A1!%20Preciso%20de%20suporte%20com%20a%20plataforma%20Trendmulti.%20Pode%20me%20ajudar%3F',
  statusPageUrl: 'https://stats.uptimerobot.com/MnlUEHco4L',
  improvementRankingUrl: 'https://gestao.trend.com.br/melhorias/ranking',
  appStoreUrl: 'https://apps.apple.com/us/app/trendmulti/id6759582214',
  googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.trendmulti.app',
  mobileAppPromoDismissed: 'mobileAppPromoDismissed',
}
